import script from "./NewClaimNew.vue?vue&type=script&setup=true&lang=js"
export * from "./NewClaimNew.vue?vue&type=script&setup=true&lang=js"

import "./NewClaimNew.vue?vue&type=style&index=0&id=642f3f79&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-642f3f79"]])

export default __exports__